import { render, staticRenderFns } from "./CrmAside.vue?vue&type=template&id=07b40095&scoped=true&"
import script from "./CrmAside.vue?vue&type=script&lang=js&"
export * from "./CrmAside.vue?vue&type=script&lang=js&"
import style0 from "./CrmAside.vue?vue&type=style&index=0&id=07b40095&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b40095",
  null
  
)

export default component.exports